import React from 'react';

import { CreditAcquisition } from 'apis/restaurant-api/merchant-admin/credits/types';

import SendOffer, { SendOfferProps } from './SendOffer';
import SentOfferWithPopup from './SentOfferWithPopup';
import { isCompensationOfferAvailable } from './utils';

type CompensationOfferProps = SendOfferProps & {
  rating: number;
  timezone: string;
  sentOffer?: CreditAcquisition;
};

const CompensationOffer = ({ rating, timezone, sentOffer, ...rest }: CompensationOfferProps) => {
  if (sentOffer) {
    return <SentOfferWithPopup timezone={timezone} sentOffer={sentOffer} />;
  }

  if (!isCompensationOfferAvailable(rating)) {
    return null;
  }

  return <SendOffer {...rest} />;
};

export default CompensationOffer;
